module.exports = function() {
  return new Worker(__webpack_public_path__ + "a9d0330e8a27fd2711d5.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/workers/worker.js
// module id = 670
// module chunks = 0